import React from "react";
import MapSrc from "../../../images/mapimage.png";

const MapPreview = () => {
  return (
    <div>
      <img className="w_100" src={MapSrc} alt="map" />
    </div>
  );
};

export default MapPreview;
